import { Award, Eye, EyeOff, GripVertical, Pencil, Trash2 } from "lucide-react";
import { mediaSrc } from "@/lib/media";
import { StarsRO } from "./Rating";

const TestimonialMedia = ({ t }) => {
  if (t.kind === "audio" && t.media_url) return <audio controls src={mediaSrc(t.media_url)} className="w-full max-w-md" />;
  if (t.kind === "video" && t.media_url) return <video controls src={mediaSrc(t.media_url)} className="w-full max-w-md rounded-xl max-h-56" />;
  if (t.kind === "image" && (t.media_urls?.length || t.media_url)) {
    return (
      <div className="space-y-2">
        <div className="flex flex-wrap gap-2">
          {(t.media_urls?.length ? t.media_urls : [t.media_url]).map((u, ui) => (
            <img key={ui} src={mediaSrc(u)} alt={`Testimonial by ${t.name} ${ui + 1}`} className="w-28 h-28 rounded-xl object-cover" />
          ))}
        </div>
        {t.text && <p className="text-foreground/90 break-words text-sm italic">"{t.text}"</p>}
      </div>
    );
  }
  return <p className="text-foreground/90 break-words">"{t.text}"</p>;
};

const iconBtn = "grid place-items-center w-8 h-8 rounded-full border border-border hover:bg-primary hover:text-primary-foreground transition-colors";

export const TestimonialRow = ({ t, index, onDragStart, onDrop, toggleFeatured, toggleTestimonialVisible, startEditT, deleteTestimonial }) => {
  const hidden = t.visible === false;
  const tone = t.featured ? "border-accent/50 bg-accent/5" : hidden ? "border-border/40 bg-muted/40 opacity-70" : "border-border bg-background/60";
  return (
    <div data-testid={`testimonial-row-${t.id}`} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(index)} className={`flex justify-between gap-3 rounded-2xl border p-4 ${tone}`}>
      <button type="button" draggable data-testid={`testimonial-drag-${t.id}`} onDragStart={() => onDragStart(index)} title="Drag to reorder"
        className="shrink-0 grid place-items-center w-7 h-8 text-muted-foreground/60 hover:text-accent cursor-grab active:cursor-grabbing">
        <GripVertical size={16} />
      </button>
      <div className="min-w-0 flex-1">
        <TestimonialMedia t={t} />
        <div className="flex flex-wrap items-center gap-2 mt-1.5">
          <span className="text-xs text-accent">— {t.name} · <span className="uppercase tracking-widest">{t.kind || "text"}</span>{hidden ? " · hidden" : ""}</span>
          {t.rating > 0 && <StarsRO value={t.rating} />}
          {t.featured && <span className="inline-flex items-center gap-1 rounded-full bg-accent text-white px-2 py-0.5 text-[10px] uppercase tracking-widest"><Award size={11} /> Featured</span>}
        </div>
      </div>
      <div className="shrink-0 inline-flex gap-2 h-fit">
        <button data-testid={`testimonial-feature-${t.id}`} onClick={() => toggleFeatured(t)} title={t.featured ? "Unfeature" : "Feature at top"}
          className={`grid place-items-center w-8 h-8 rounded-full border transition-colors ${t.featured ? "bg-accent text-white border-accent" : "border-border hover:bg-primary hover:text-primary-foreground"}`}>
          <Award size={14} />
        </button>
        <button data-testid={`testimonial-visible-${t.id}`} onClick={() => toggleTestimonialVisible(t)} title={hidden ? "Show on site" : "Hide from site"} className={iconBtn}>
          {hidden ? <EyeOff size={14} /> : <Eye size={14} />}
        </button>
        <button data-testid={`testimonial-edit-${t.id}`} onClick={() => startEditT(t)} title="Edit" className={iconBtn}><Pencil size={14} /></button>
        <button data-testid={`testimonial-delete-${t.id}`} onClick={() => deleteTestimonial(t)} title="Delete"
          className="grid place-items-center w-8 h-8 rounded-full border border-destructive/40 text-destructive hover:bg-destructive hover:text-white transition-colors">
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  );
};
